import {useProductColumns} from './product-columns-context';

import type {GroupSingleOption, OptionGroups, OptionTab} from '@pb/kit-component-modal-options';
import type {SearchTemplateColumn} from 'src/modules/advanced-search-result/typedef';

type Props = {
    columns: Record<string, string>, columnsMap: SearchTemplateColumn[], items: OptionTab[],
    allOptions: GroupSingleOption[], optionGroups: OptionGroups, noSortColumns: string[],
};

export const useProductColumnOptions = (base: Props) => {
    const {productColumns, columnMap, ready} = useProductColumns();
    const options: GroupSingleOption[] = productColumns.map(({code, name}) => ({
        hidden: false,
        defaultOption: false,
        option: {optionId: code, label: name, fixed: false, pinned: false},
    }));
    const tabId = base.items[0].tabId;
    return {
        ready,
        columns: {...base.columns, ...columnMap},
        columnsMap: [...base.columnsMap, ...productColumns],
        noSortColumns: [...base.noSortColumns, ...productColumns.map(({code}) => code)],
        allOptions: [...base.allOptions, ...options],
        items: base.items.map((tab, index) => index === 0 && options.length ? {
            ...tab,
            items: [...tab.items || [], {id: 'products', caption: 'Products', collapsible: false, options}],
        } : tab),
        optionGroups: {
            ...base.optionGroups,
            [tabId]: [...base.optionGroups[tabId], ...options.length ? [{options: ['products']}] : []],
        },
    };
};
